import React from 'react';
import { Box, Container } from '@mui/material';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import UpfrontRentsList from './UpfrontRentsListView/UpfrontRentsList';
import Toolbar from './UpfrontRentsListView/Toolbar';
import useStyles from './styles';

const UpfrontRentsListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page
      className={classes.ContainerRoot}
      title={t('NAVIGATION.UPFRONT_RENTS')}
    >
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <UpfrontRentsList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default UpfrontRentsListView;
